iScreenWizard.factory('Groepsprofieloptie', function ($q, Ajax) {

    var data = {};

    data.all = function(params) {
        if (typeof params === 'undefined') {
            params = {};
        }
        return $q(function (resolve, reject) {
            Ajax.get('groepsprofieloptie', params).then(function (response) {
                var groepsprofielopties = response.data;
                resolve(groepsprofielopties);
            }, reject);
        });
    };

    data.get = function(id) {
        return $q(function (resolve, reject) {
            Ajax.get('groepsprofieloptie/'+id).then(function (response) {
                var groepsprofieloptie = response.data;
                resolve(groepsprofieloptie);
            }, reject);
        });
    };

    return data;
});